import { LocationOption } from "@app/schemas/biq";

export const CAREER_AREAS: {
  icon: string,
  name: string,
}[] = [
  {
    icon: "manufacturing.svg",
    name: "Advanced Manufacturing",
  }, {
    icon: "construction.svg",
    name: "Construction",
  }, {
    icon: "transportation.svg",
    name: "Supply Chain & Transportation",
  }, {
    icon: "arts.svg",
    name: "Arts, Entertainment, & Design",
  }, {
    icon: "hospitality.svg",
    name: "Hospitality, Events, & Tourism",
  }, {
    icon: "financial.svg",
    name: "Financial Services",
  }, {
    icon: "education.svg",
    name: "Education",
  }, {
    icon: "healthcare.svg",
    name: "Healthcare & Human Services",
  }, {
    icon: "public.svg",
    name: "Public Service & Safety",
  }, {
    icon: "agriculture.svg",
    name: "Agriculture",
  }, {
    icon: "energy.svg",
    name: "Energy & Natural Resources",
  }, {
    icon: "technology.svg",
    name: "Digital Technology",
  }, {
    icon: "management.svg",
    name: "Management & Entrepreneurship",
  }, {
    icon: "marketing.svg",
    name: "Marketing & Sales",
  }
];

type categoryType = {
  title: string,
  description: string,
}
export const RIASEC_CATEGORIES: Record<string, categoryType> = {
  realistic: {
    title: "Realistic",
    description: "Practical and hands-on, you prefer tools, machines, or the outdoors.",
  },
  investigative: {
    title: "Investigative",
    description: "Analytical and curious, you enjoy solving problems and exploring ideas.",
  },
  artistic: {
    title: "Artistic",
    description: "Creative and expressive, you thrive in unstructured, imaginative work.",
  },
  social: {
    title: "Social",
    description: "Empathetic and communicative, you enjoy helping, teaching, and people.",
  },
  enterprising: {
    title: "Enterprising",
    description: "Persuasive and ambitious, you excel in leadership and competitive roles.",
  },
  conventional: {
    title: "Conventional",
    description: "Detail-oriented and organized, you prefer structured tasks and systems.",
  }
}

export const NAVBAR_MENU_ITEMS = [
  {
    name: 'Explore Careers',
    active: false,
    trackEvent: 'Tab Navigate Explore',
    section: 'explore',
  },
  {
    name: 'Build Your Plan',
    active: false,
    trackEvent: 'Tab Navigate Plan',
    section: 'plan',
  },
  {
    name: 'Find a Job',
    active: false,
    trackEvent: 'Tab Navigate Job',
    section: 'job',
  },
];

export type ItemTags = 'survey' | 'resume' | 'communication' | 'durable' | 'goal' | 'plan' | 'job';

export type ListItem = {
  title: string;
  status: 'todo' | 'pending' | 'completed' | 'locked';
  statusText: string;
  time: string;
  description: string;
  tag: ItemTags;
  hover?: string;
}

export const CAREER_RESULT_CHECKLIST_ITEMS: ListItem[] = [
  {
    title: "Take Career Interest Survey",
    status: "completed",
    statusText: "",
    time: "Approx 15 min",
    description: "",
    tag: 'survey', 
  },
  {
    title: "Add Resume",
    status: "pending",
    statusText: "TO DO",
    time: "Approx. 2 min",
    description: "Every experience builds valuable skills - add yours to refine your matches.",
    tag: 'resume', 
  },
  {
    title: "Take Communication Skills Assessment",
    status: "pending",
    statusText: "TO DO",
    time: "Approx. 14 min",
    description: "Communication is a must-have skill for any job - explore your style and ways to improve.", 
    tag: 'communication',
  },
  {
    title: "Take Durable Skills Assessment",
    status: "pending",
    statusText: "TO DO",
    time: "Approx. 25 min",
    description: "Understand your strengths in key work readiness skills like collaboration, resilience and creativity.",
    tag: 'durable', 
  },
  {
    title: "Set Career Goal",
    status: "pending",
    statusText: "TO DO",
    time: "Approx. 5 min",
    description: "Choose a career goal to personalize your plan.", 
    tag: 'goal',
  },
  {
    title: "Generate Plan",
    status: "locked",
    statusText: "TO DO",
    time: "Approx. 1 min",
    description: "Discover your strengths and get guidance on what to work on next.", 
    tag: 'plan',
    hover: 'Complete your checklist to unlock your personalized plan',
  },
  {
    title: "Share a New Job/Internship",
    status: "pending",
    statusText: "TO DO",
    time: "Approx. 2 min",
    description: "Did you land something? Tell us about it!",
    tag: 'job',
  },
];

export const US_LOCATIONS: LocationOption[] = [
  { city: 'Glendale', state: 'CA', display: 'Glendale, CA' },
  { city: 'Los Angeles', state: 'CA', display: 'Los Angeles, CA' },
  { city: 'New York', state: 'NY', display: 'New York, NY' },
  { city: 'Chicago', state: 'IL', display: 'Chicago, IL' },
  { city: 'Houston', state: 'TX', display: 'Houston, TX' },
  { city: 'Phoenix', state: 'AZ', display: 'Phoenix, AZ' },
  { city: 'Philadelphia', state: 'PA', display: 'Philadelphia, PA' },
  { city: 'San Antonio', state: 'TX', display: 'San Antonio, TX' },
  { city: 'San Diego', state: 'CA', display: 'San Diego, CA' },
  { city: 'Dallas', state: 'TX', display: 'Dallas, TX' },
];

export const BIQ_GENDER: { label: string, value: string, checked: boolean }[] = [
  { label: 'Male', value: 'Male', checked: false },
  { label: 'Female', value: 'Female', checked: false },
  { label: 'Non-binary', value: 'Non-binary', checked: false },
  { label: 'Prefer not to answer', value: 'Prefer not to answer', checked: false }
];

export const BIQ_ETHNICITY: { label: string, value: string }[] = [
  { 
    label: 'American Indian or Alaskan Native', 
    value: 'American Indian or Alaskan Native' 
  },
  { 
    label: 'Asian or Asian American', 
    value: 'Asian or Asian American' 
  },
  { 
    label: 'Black or African American', 
    value: 'Black or African American' 
  },
  { 
    label: 'Hispanic or Latin-American', 
    value: 'Hispanic or Latin-American' 
  },
  { 
    label: 'Native Hawaiian or Other Pacific Islander', 
    value: 'Native Hawaiian or Other Pacific Islander' 
  },
  { 
    label: 'White (non-Hispanic)', 
    value: 'White (non-Hispanic)' 
  },
  { 
    label: 'Prefer not to answer', 
    value: 'Prefer not to answer' 
  },
];

export const SCHOOL_YEAR: {
  label: string,
  value: string,
}[] = [
  { label: 'Freshman', value: 'Freshman' },
  { label: 'Sophomore', value: 'Sophomore' },
  { label: 'Junior', value: 'Junior' },
  { label: 'Senior', value: 'Senior' },
  { label: 'Graduate Student', value: 'Graduate Student' },
  { label: 'Other', value: 'Other' },
];

export const SCHOOL_TYPE: {
  label: string,
  value: string,
}[] = [
  { label: '4-year Public State', value: '4-year Public State' },
  { label: '4-year Private State', value: '4-year Private State' },
  { label: 'Trade/Techinical School', value: 'Trade/Techinical School' },
  { label: 'Other', value: 'Other' },
];

export const SCHOOL_NAMES: {
  label: string,
  value: string,
}[] = [
    { label: 'CSU Dominguez Hills', value: 'CSU Dominguez Hills' },
    { label: 'CSU Fullerton', value: 'CSU Fullerton' },
    { label: 'CSU Long Beach', value: 'CSU Long Beach' },
    { label: 'CSU Northridge', value: 'CSU Northridge' },
    { label: 'CSU San Bernardino', value: 'CSU San Bernardino' },
    { label: 'CSU San Marcos', value: 'CSU San Marcos' },
    { label: 'Cal Poly Pomona', value: 'Cal Poly Pomona' },
    { label: 'Cal Poly San Luis Obispo', value: 'Cal Poly San Luis Obispo' },
    { label: 'Cal State LA', value: 'Cal State LA' },
    { label: 'Fresno State University', value: 'Fresno State University' },
    { label: 'San Jose State University', value: 'San Jose State University' },
    // { label: 'American University', value: 'American University' }, No need as auto-set for AU tenants but kept for reference
  ];

export const JOB_OPTIONS: {
  label: string,
  value: string,
  checked: boolean,
}[] = [
  { label: 'Part Time', value: 'part_time', checked: false },
  { label: 'Full Time', value: 'full_time', checked: false },
];

export const BIQ_TOTAL_QUESTIONS = 7;

export const CAREER_FILTER_DEFAULT_OPTIONS = {
  area: [],
  quality: {
    h1_plus: true,
    h1: true,
    med: true,
    low: true,
  },
  education: {
    high_school: true,
    associate_degree: true,
    bachelor_degree: true,
    graduate: true,
  },
  salary: {
    min_value: 30,
    max_value: 240,
  }
}

export const ONET_LOCAL_KEY = 'onet-code';
export const CAREER_GOAL_LOCAL_KEY = 'career-goal';
export const CAREER_GOAL_DETAILS_LOCAL_KEY = 'career-goal-details';
export const BYP_PLAN_GENERATED_LOCAL_KEY = 'byp-generated';
export const USER_RESUME_LOCAL_KEY = 'user-resume-uploaded';

export const MY_PROFILE_LINKS = [
  {
    label: "Resume",
    key: "resume",
    display: true,
  },
  {
    label: "Career Interest Results",
    key: "survey",
    display: false,
  },
  {
    label: "Communication Assessment",
    key: "edge-communication",
    display: false,
  },
  {
    label: "Durable Skills Assessment",
    key: "edge-behaviour",
    display: false,
  }
]

export const JOB_TYPE = ["FULL_TIME", "PART_TIME"];

export const JOB_LOCATION = ["IN_PERSON", "REMOTE"]

export const JOB_FILTER_DEFAULT_OPTIONS = {
  role: ["FULL_TIME", "PART_TIME"],
  education: 'HIGH_SCHOOL',
  location: ["IN_PERSON", "REMOTE"],
  is_bookmarked: false,
  is_related_to_career_goal: true,
}

export const JOB_SORT_BY_OPTIONS = [
  {
    label: 'Highest Match',
    value: 'match_score_category',
  },
  {
    label: 'Date Posted',
    value: 'posting_date',
  },
]
